// M12 - MotricityProgressionLine
//
// Line chart de progresion temporal de N sesiones de un juego.
// Acepta varias series para comparar metricas (p.ej. faults vs duracion).

import React, { useMemo } from "react";
import { Card, Empty } from "antd";
import { Line } from "@ant-design/charts";

export function MotricityProgressionLine({
  title,
  series, // [{ name, points: [{date, value}] }]
  height = 280,
  emptyHint = "Se necesitan al menos 2 sesiones para ver evolucion",
}) {
  const data = useMemo(() => {
    if (!Array.isArray(series)) return [];
    return series.flatMap((s) =>
      (s.points || []).map((p) => ({
        date: p.date,
        value: Number(p.value) || 0,
        serie: s.name,
      })),
    );
  }, [series]);

  const minPointsPerSerie = useMemo(() => {
    if (!Array.isArray(series) || series.length === 0) return 0;
    return Math.max(...series.map((s) => (s.points || []).length));
  }, [series]);

  const config = useMemo(
    () => ({
      data,
      xField: "date",
      yField: "value",
      seriesField: "serie",
      colorField: "serie",
      height,
      autoFit: true,
      smooth: true,
      point: { size: 4 },
      legend: { position: "bottom" },
    }),
    [data, height],
  );

  return (
    <Card title={title} variant="outlined">
      {minPointsPerSerie < 2 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyHint} />
      ) : (
        <Line {...config} />
      )}
    </Card>
  );
}
